import React from 'react'
import { RegistryActiveFilters } from './RegistryActiveFilters/RegistryActiveFilters'
import { RegistryFiltersDialog } from './RegistryFiltersDialog/RegistryFiltersDialog'
import type { SelectedFilterValues } from './RegistryFiltersDialog/RegistryFiltersDialog.logic'
import type { FilterFacet, FilterFacetKey } from './RegistryFilters.static'

export interface RegistryFilterPanelProps {
  readonly isOpen: boolean
  readonly facets: readonly FilterFacet[]
  readonly selectedValues: SelectedFilterValues
  readonly onApply: (values: SelectedFilterValues) => void
  readonly onOpenDialog: () => void
  readonly onCloseDialog: () => void
  readonly onFacetCleared: (key: FilterFacetKey) => void
  readonly onClearAll: () => void
}

export const RegistryFilterPanel: React.FC<RegistryFilterPanelProps> = ({
  isOpen,
  facets,
  selectedValues,
  onApply,
  onOpenDialog,
  onCloseDialog,
  onFacetCleared,
  onClearAll,
}) => (
  <>
    <RegistryFiltersDialog
      isOpen={isOpen}
      facets={facets}
      selectedValues={selectedValues}
      onApply={onApply}
      onClose={onCloseDialog}
    />
    <RegistryActiveFilters
      facets={facets}
      selectedValues={selectedValues}
      onFacetCleared={onFacetCleared}
      onFacetChipClicked={onOpenDialog}
      onClearAll={onClearAll}
    />
  </>
)
